import * as moment from 'moment';

export class ApiUtils {
  static convert(
    data: string | number | boolean | Date | any[] | File
  ): string | File | File[] {
    if (['boolean', 'number', 'string'].indexOf(typeof data) > -1) {
      return data.toString();
    }

    if (data instanceof Date) {
      return moment(data).format('YYYY-MM-DD');
    }

    if (moment.isMoment(data)) {
      return data.toISOString();
    }

    // TODO : fix type
    if (Array.isArray(data)) {
      if (data.every((it) => it instanceof File)) {
        return data;
      }

      if (data.every((it) => typeof it === 'string')) {
        return data.join(',');
      }
      return JSON.stringify(data);
    }

    if (data instanceof File) {
      return data;
    }

    throw new Error('Cannot convert input into data for endpoint');
  }

  static toUnderscoreCase(s: string): string {
    return s.replace(/\.?([A-Z]+)/g, (x, y) => `${y}`);
  }
}
